<script setup>
import { onMounted, ref, computed } from "vue";

const props = defineProps(["modelValue", "isAuth"]);

defineEmits(["update:modelValue"]);

const classes = computed(() =>
  props.isAuth
    ? "text-oteoText border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm py-2"
    : "text-oteoText bg-oteoInputBG border-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm py-2"
);
</script>

<template>
  <select
    :class="classes"
    v-model="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  >
    <slot />
  </select>
</template>
